/**
 * @Component
 * Components for Dock page
 *
 */
import { Component, OnInit, ViewChild, Inject, ElementRef, Input, AfterViewChecked, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { AuthService } from '../shared/services/auth.service';
import { environment } from '../../environments/environment';
import { MemberService } from '../shared/services/member.service';
import { DockService } from '../shared/services/dock.service';
import { Dock } from '../shared/models/dock.model';
import { HttpService } from '../shared/services/http.service';

import { ListItem } from '../list-item/list-item.component';
import { FeedService, Feed } from '../shared/services/feed.service';

//import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ng2-page-scroll';
//declare var $:JQueryStatic;
//import { SlickModule } from 'ngx-slick';

@Component({
    selector: 'app-dock',
    templateUrl: './home.component.html',
    styleUrls: [
        './home.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})

export class HomeComponent implements OnInit, AfterViewChecked {
    
    roleId: number = null;
    docks: Dock[] = [];

    busy: Promise<any>;
    private apiModelUrl = environment.apiUrl + 'dock/';

    outdatedBrowserRework = require("outdated-browser-rework");
    articles: any[];
    //@Input()
    items: ListItem[];
    //items: any;

    //@ViewChild()
    //rootPage = FeedList;
    //feeds: Feed[];
    //feeds2: any[];
    feed: any;
    urlRSS = "http://www.adapei12-82.fr/feed/";
    title: string;

    class_item = 0;
    slideConfig;
    label_title: string;
    own_info: string;
    assist_title: string;
    assist_text: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private toastyService: ToastyService,
        private authService: AuthService,
        //public tools: Tools,
        private memberService: MemberService,

        private http: HttpService,
        private dockService: DockService,
        private feedService: FeedService,

        //private pageScrollService: PageScrollService,
        //@Inject(this.feed) private article: any
    ) { }


    ngOnInit() {

        this.slideConfig = {
            "slidesToShow": 1, "slidesToScroll": 1, "autoplay": true, "adaptiveHeight": true, "accessibility": true, "autoplaySpeed": 4000, "arrows": false };

        this.busy = this.memberService.getRoles(+this.authService.tokenGet().userId).then(resp => {
            this.roleId = resp[0].id;
            if (+this.roleId !== 1) {
                console.log("ROLE !!??");
                //this.router.navigate(['home']);
            }
            console.log("-> getAllDocks ??");
            this.dockService.getAllDocks().then(resp => {
                this.docks = resp;
                // Flag loading
                //this.dataLoaded = true;
                console.log(this.docks);
                //this.loadFeeds();
                this.feedService.getFeedInfo().then(response => {
                    console.log(response);
                    this.label_title = response.label;
                    this.own_info = response.text;
                    this.feedService.getFeed(response.url).then(response => {
                        console.log(response);

                        this.feed = response.feed;
                        this.title = response.feed.title;
                        //this.items = response.items.slice(0,6);
                        this.items = response.items;
                        
                        this.outdatedBrowserRework({
                            browserSupport: {
                                'Chrome': 37, // Includes Chrome for mobile devices
                                'IE': 13,
                                'Safari': 7,
                                'Mobile Safari': 7,
                                'Firefox': 32
                            }
                        });

                        this.feedService.getAssistInfo().then(response => {
                            console.log(response);
                            this.assist_title = response.label;
                            this.assist_text = response.text;
                        });

                    });
                });

            });
        });
    }

    ngAfterViewChecked() {
        //console.log("ok");

    }
    
    goto(url: string) {
        //console.log(url);
        if (url.substring(0, 4) == "http") {
            window.open(url, '_blank');
        } else {
            window.location.href = url;
        }
    }
    
    //private loadFeeds() {
    //    var dis = this.feedService.getArticlesForUrl("http://backend.deviantart.com/rss.xml").subscribe(list => {
    //        console.log(list);
    //    })
    //    console.log(dis);
    //    return dis;
    //}

    afterChange(e) {
        //console.log('afterChange');
    }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts